import styled from "styled-components";
import { RUBIK } from "../../index.style.ts";

export const Title = styled.div`
  font-family: ${RUBIK};
  font-size: 18px;
  font-weight: 600;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
`;

export const Wrapper = styled.div`
  margin-bottom: 20px;

  ul {
    margin: 0;
  }

  strong {
    font-weight: 500;
  }
`;
